/**
 * Finds a section by its id in a list of sections and returns the value of the
 * given key on that section.
 * @param {Array<{ id: string, [key: string]: any }>} data List of sections.
 * @param {string} area Section id to look up (e.g. a `PERSONAL_AREA` value).
 * @param {string} key Property name to read from the matched section.
 * @returns {*} The value of `section[key]`, or `undefined` if no section matches.
 */
export const pickSection = (data, area, key) =>
  data.find(({ id }) => id === area)?.[key]
